/**
 * TODO: получать компонент из svg через библиотеку svgr, чтобы избежать дублирования кода
 */

export const TreatmentOfBottomholeZone = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx={6} cy={6} r={4.5} stroke="#fff" />
        <circle cx={6} cy={6} r={3.5} fill="#FFC107" stroke="#FF5252" />
    </svg>
);
TreatmentOfBottomholeZone.svg = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="6" r="4.5" stroke="white" />
        <circle cx="6" cy="6" r="3.5" fill="#FFC107" stroke="#FF5252" />
    </svg>
);

export const StratumHydraulicFracturing = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6.557 2.045a.6.6 0 0 0-1.114 0l-.825 2.054-2.208.15a.6.6 0 0 0-.344 1.058l1.698 1.42-.54 2.146a.6.6 0 0 0 .901.654L6 8.35l1.874 1.177a.6.6 0 0 0 .901-.654l-.54-2.147 1.698-1.419a.6.6 0 0 0-.344-1.059l-2.208-.15-.824-2.053Z"
            fill="#fff"
            stroke="#fff"
        />
        <path
            d="m4.937 5.08-.034-.5.034.5a.6.6 0 0 0 .516-.376L6 3.342l.547 1.362a.6.6 0 0 0 .517.375l.033-.499-.033.5 1.464.099-1.126.941a.6.6 0 0 0-.197.607l.358 1.424-1.244-.781a.6.6 0 0 0-.638 0l-1.243.78.358-1.423a.6.6 0 0 0-.197-.607l-.32.384.32-.384-1.127-.941 1.465-.1Zm3.139-1.937-.591-1.47c-.537-1.34-2.432-1.34-2.97 0l-.59 1.47-1.582.108c-1.439.097-2.024 1.9-.918 2.824L2.642 7.09 2.255 8.63c-.352 1.398 1.181 2.512 2.403 1.745L6 9.531l1.343.843c1.221.767 2.754-.347 2.402-1.745L9.36 7.09l1.216-1.016c1.107-.925.521-2.727-.917-2.824l-1.582-.108Z"
            fill="#FF5252"
            stroke="#fff"
        />
    </svg>
);
StratumHydraulicFracturing.svg = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.55653 2.04487C6.35499 1.54299 5.6445 1.54298 5.44296 2.04487L4.61823 4.09862L2.41014 4.24834C1.87055 4.28493 1.65099 4.96063 2.06603 5.3074L3.76441 6.72641L3.22447 8.87269C3.09252 9.39719 3.66731 9.8148 4.12536 9.52723L5.99974 8.35048L7.87413 9.52723C8.33218 9.8148 8.90697 9.39718 8.77502 8.87269L8.23508 6.72641L9.93346 5.3074C10.3485 4.96063 10.1289 4.28493 9.58935 4.24834L7.38126 4.09862L6.55653 2.04487Z"
            fill="white"
            stroke="white"
        />
        <path
            d="M4.93694 5.07934L4.90311 4.58048L4.93694 5.07934C5.16672 5.06376 5.36731 4.91803 5.45313 4.7043L6.00025 3.34186L6.54737 4.7043C6.6332 4.91803 6.83379 5.06376 7.06357 5.07934L7.09739 4.58048L7.06357 5.07934L8.5284 5.17866L7.40171 6.12002C7.22496 6.26769 7.14835 6.5035 7.20454 6.72684L7.56273 8.15068L6.31928 7.37002C6.12422 7.24757 5.87628 7.24757 5.68123 7.37002L4.43777 8.15068L4.79597 6.72685C4.85216 6.5035 4.77554 6.26769 4.5988 6.12003L4.27822 6.50372L4.5988 6.12002L3.47211 5.17866L4.93694 5.07934ZM8.07579 3.14338L7.48501 1.67222C6.94757 0.333876 5.05294 0.333862 4.5155 1.67222L3.92472 3.14338L2.343 3.25063C0.904084 3.3482 0.318599 5.15009 1.42537 6.0748L2.64197 7.09128L2.25519 8.62872C1.90333 10.0274 3.43611 11.141 4.65758 10.3742L6.00025 9.53122L7.34293 10.3742C8.56439 11.141 10.0972 10.0274 9.74531 8.62872L9.35854 7.09128L10.5751 6.0748C11.6819 5.15009 11.0964 3.3482 9.6575 3.25063L8.07579 3.14338Z"
            fill="#FF5252"
            stroke="white"
        />
    </svg>
);

export const PerforationAndReperforation = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M3 6.5v3M6 4.5v5M9 2.5v7" stroke="#FF5252" />
    </svg>
);
PerforationAndReperforation.svg = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6.5V9.5" stroke="#FF5252" />
        <path d="M6 4.5V9.5" stroke="#FF5252" />
        <path d="M9 2.5V9.5" stroke="#FF5252" />
    </svg>
);

export const RepairAndInsulationWorks = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M2.566 6.707a1 1 0 0 1 0-1.414l2.829-2.829a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L6.809 9.536a1 1 0 0 1-1.414 0L2.566 6.707Z"
            fill="#fff"
        />
        <path
            d="M6.102 8.121 3.981 6l2.121-2.121L8.223 6 6.102 8.121ZM2.212 4.94a1.5 1.5 0 0 0 0 2.122l2.83 2.828a1.5 1.5 0 0 0 2.12 0l2.83-2.828a1.5 1.5 0 0 0 0-2.122l-2.83-2.828a1.5 1.5 0 0 0-2.12 0l-2.83 2.828Z"
            fill="#FF5252"
            stroke="#fff"
        />
    </svg>
);
RepairAndInsulationWorks.svg = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.56648 6.70711C2.17596 6.31658 2.17596 5.68342 2.56648 5.29289L5.39491 2.46447C5.78543 2.07394 6.4186 2.07394 6.80912 2.46447L9.63755 5.29289C10.0281 5.68342 10.0281 6.31658 9.63755 6.70711L6.80912 9.53553C6.4186 9.92606 5.78543 9.92606 5.39491 9.53553L2.56648 6.70711Z"
            fill="white"
        />
        <path
            d="M6.10202 8.12132L3.9807 6L6.10202 3.87868L8.22334 6L6.10202 8.12132ZM2.21293 4.93934C1.62714 5.52513 1.62714 6.47487 2.21293 7.06066L5.04136 9.88909C5.62714 10.4749 6.57689 10.4749 7.16268 9.88909L9.9911 7.06066C10.5769 6.47487 10.5769 5.52513 9.9911 4.93934L7.16268 2.11091C6.57689 1.52513 5.62714 1.52513 5.04136 2.11091L2.21293 4.93934Z"
            fill="#FF5252"
            stroke="white"
        />
    </svg>
);

export const WellOperationModeOptimization = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx={6} cy={6} r={4.5} stroke="#fff" />
        <circle cx={6} cy={6} r={3.5} fill="#fff" stroke="#FF5252" />
        <path d="M6 8V4" stroke="#FF5252" />
    </svg>
);
WellOperationModeOptimization.svg = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="6" r="4.5" stroke="white" />
        <circle cx="6" cy="6" r="3.5" fill="white" stroke="#FF5252" />
        <path d="M6 8L6 4" stroke="#FF5252" />
    </svg>
);

export const HorizontalSidetracking = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x={5.5} y={3.5} width={5} height={5} rx={2.5} fill="#fff" stroke="#FF5252" />
        <rect x={1.5} y={5.5} width={1} height={1} rx={0.5} fill="#fff" stroke="#FF5252" />
        <path d="M2.5 6h3" stroke="#FF5252" />
    </svg>
);
HorizontalSidetracking.svg = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5.5" y="3.5" width="5" height="5" rx="2.5" fill="white" stroke="#FF5252" />
        <rect x="1.5" y="5.5" width="1" height="1" rx="0.5" fill="white" stroke="#FF5252" />
        <path d="M2.5 6L5.5 6" stroke="#FF5252" />
    </svg>
);

export const Returns = props => (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect
            x={8.5}
            y={5.5}
            width={5}
            height={5}
            rx={2.5}
            transform="rotate(90 8.5 5.5)"
            fill="#fff"
            stroke="#FF5252"
        />
        <rect
            x={6.5}
            y={1.5}
            width={1}
            height={1}
            rx={0.5}
            transform="rotate(90 6.5 1.5)"
            fill="#fff"
            stroke="#FF5252"
        />
        <path d="M6 2.5v3" stroke="#FF5252" />
    </svg>
);
Returns.svg = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="8.5"
            y="5.5"
            width="5"
            height="5"
            rx="2.5"
            transform="rotate(90 8.5 5.5)"
            fill="white"
            stroke="#FF5252"
        />
        <rect
            x="6.5"
            y="1.5"
            width="1"
            height="1"
            rx="0.5"
            transform="rotate(90 6.5 1.5)"
            fill="white"
            stroke="#FF5252"
        />
        <path d="M6 2.5V5.5" stroke="#FF5252" />
    </svg>
);
